'use client';
import React, { ReactNode } from 'react';
import { sanitize } from '@jill64/universal-sanitizer';
import './blocks.css';

export type ComponentProps = {
	htmlString: string;
	flex?: boolean;
	alignment?: 'Left' | 'Center' | 'Right';
};

export function RichContentBlock({ htmlString, flex, alignment }: ComponentProps): ReactNode {
	// Sanitize the HTML string before rendering
	const sanitizedHtml = sanitize(htmlString);
	let alignClass = '';

	switch (alignment) {
		case 'Left':
			alignClass = flex ? 'items-start' : 'text-left';
			break;
		case 'Center':
			alignClass = flex ? 'items-center' : 'text-center';
			break;
		case 'Right':
			alignClass = flex ? 'items-end' : 'text-right';
			break;
		default:
			alignClass = '';
			break;
	}

	return (
		<span
			className={`${flex ? 'flex flex-col' : 'inline'} ${alignClass} rich-content`}
			dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
		/>
	);
}
